import React from 'react';
import { ArrowUpRight, Sparkles, Database, Code2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { projectsData } from '../data/mock';

const projectIcons = {
  'NEXPER.ai': Sparkles,
  'Aurum': Database,
  'STARKLANG': Code2
};

export const ProjectsSection = () => {
  return (
    <section id="projects" className="py-32 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Section Title */}
        <h2 className="text-4xl sm:text-5xl font-extralight text-black mb-16 tracking-tight">
          {projectsData.title}
        </h2>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {projectsData.items.map((project) => {
            const IconComponent = projectIcons[project.name] || Sparkles;
            return (
              <Card
                key={project.id}
                className="border border-gray-200 bg-white hover:shadow-lg transition-all duration-300 hover:-translate-y-2 group flex flex-col"
              >
                <CardContent className="p-8 flex flex-col flex-1">
                  {/* Header */}
                  <div className="flex items-start justify-between mb-6">
                    <div className="w-14 h-14 rounded-2xl bg-gray-50 flex items-center justify-center group-hover:bg-gray-100 transition-colors duration-300">
                      <IconComponent className="w-7 h-7 text-black" strokeWidth={1.5} />
                    </div>
                    <Badge
                      variant="outline"
                      className={`text-xs font-normal ${
                        project.status === 'Active'
                          ? 'border-green-200 text-green-700 bg-green-50'
                          : 'border-amber-200 text-amber-700 bg-amber-50'
                      }`}
                    >
                      {project.status}
                    </Badge>
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-normal text-black mb-2 flex items-center gap-2">
                    {project.name}
                    <ArrowUpRight className="w-5 h-5 text-gray-300 group-hover:text-black group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
                  </h3>
                  <p className="text-sm text-gray-400 mb-4 font-light">
                    {project.tagline}
                  </p>
                  <p className="text-gray-600 font-light leading-relaxed mb-6 flex-1">
                    {project.description}
                  </p>

                  {/* Features */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.features.slice(0, 4).map((feature, index) => (
                      <span
                        key={index}
                        className="text-xs text-gray-500 bg-gray-50 px-3 py-1.5 rounded-full"
                      >
                        {feature}
                      </span>
                    ))}
                    {project.features.length > 4 && (
                      <span className="text-xs text-gray-400 px-3 py-1.5">
                        +{project.features.length - 4} more
                      </span>
                    )}
                  </div>

                  {/* Note */}
                  {project.note && (
                    <p className="text-sm text-gray-400 italic font-light border-t border-gray-100 pt-4 mt-auto">
                      {project.note}
                    </p>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
